import { createSelector } from 'reselect';
import _ from 'lodash';

import * as Service from 'types/service';
import { elmPartiesSelector } from './elmPartiesSelector';
import { partyToTableSelector } from './tableToPartySelector';
import PartyStates from 'constants/partyStateConstants';

function computeSeatedTables(
  partyIdToTableId?: { [partyId: string]: number[] },
  parties?: NumericDictionary<Service.PartyFromElm>
) {
  const seatedPartyIds = _.map(
    _.filter(parties, (party) => party.state === PartyStates.seated),
    'id'
  );
  const tablesWithSeatedParties = _.flattenDeep(
    _.values(
      _.pickBy(partyIdToTableId, (value, partyId) =>
        _.includes(seatedPartyIds, parseInt(partyId, 10))
      )
    )
  );
  return _.countBy(tablesWithSeatedParties);
}

export default createSelector(partyToTableSelector, elmPartiesSelector, computeSeatedTables);
